import { departmentActionTypes } from '@Actions/departmentActions';

const DepartmentReducer = (state = { }, action) => {
  switch (action.type) {
  case departmentActionTypes.CREATE_DEPARTMENT.LOADING: {
    const { createDepartmentLoading } = action;
    return {
      ...state,
      createDepartmentLoading,
    };
  }
  case departmentActionTypes.CREATE_DEPARTMENT.SUCCESS: {
    const { createdDepartment } = action;
    return {
      ...state,
      createdDepartment,
    };
  }
  case departmentActionTypes.GET_DEPARTMENTS.LOADING: {
    const { getDepartmentsLoading } = action;
    return {
      ...state,
      getDepartmentsLoading,
    };
  }
  case departmentActionTypes.GET_DEPARTMENTS.SUCCESS: {
    const { departments } = action;
    return {
      ...state,
      departments,
    };
  }
  case departmentActionTypes.GET_DEPARTMENT_BY_ID.LOADING: {
    const { getDepartmentById } = action;
    return {
      ...state,
      getDepartmentById,
    };
  }
  case departmentActionTypes.GET_DEPARTMENT_BY_ID.SUCCESS: {
    const { selectedDepartment } = action;
    return {
      ...state,
      selectedDepartment,
    };
  }
  case departmentActionTypes.UPDATE_DEPARTMENT.LOADING: {
    const { updateDepartmentLoading } = action;
    return {
      ...state,
      updateDepartmentLoading,
    };
  }
  case departmentActionTypes.UPDATE_DEPARTMENT.SUCCESS: {
    const { updatedCustomer } = action;
    return {
      ...state,
      updatedCustomer,
    };
  }
  case departmentActionTypes.UPDATE_STATUS_DEPARTMENT.LOADING: {
    const { updateDepartmentStatusLoading } = action;
    return {
      ...state,
      updateDepartmentStatusLoading,
    };
  }
  case departmentActionTypes.DELETE_DEPARTMENT.LOADING: {
    const { deleteDepartmentLoading } = action;
    return {
      ...state,
      deleteDepartmentLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default DepartmentReducer;
